import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const LandingPageFooter: React.FC = () => {
  return (
    <footer className="bg-[rgba(10,25,47,0.8)] border-t border-white/10 pt-16 pb-8 px-4 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <img src="/lognow_branco.svg" alt="LOGNOW" className="h-10 mb-6" />
            <p className="text-white/70 mb-6">
              A sua solução completa para vendas online. Facilite as suas vendas, ligue ao seu próprio site e aloque os seus produtos aos melhores marketplaces europeus.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#8cc63f] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#8cc63f] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#8cc63f] transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <a href="#como-funciona" className="text-white/70 hover:text-[#8cc63f] transition-colors">Como Funciona</a>
              </li>
              <li>
                <a href="#produtos" className="text-white/70 hover:text-[#8cc63f] transition-colors">Produtos</a>
              </li>
              <li>
                <a href="#marketplaces" className="text-white/70 hover:text-[#8cc63f] transition-colors">Marketplaces</a>
              </li>
              <li>
                <a href="#planos" className="text-white/70 hover:text-[#8cc63f] transition-colors">Planos</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contactos</h3>
            <ul className="space-y-3">
              <li className="flex items-center">
                <Mail size={18} className="text-[#8cc63f] mr-2" />
                <a href="mailto:ola@lognow.pt" className="text-white/70 hover:text-[#8cc63f] transition-colors">ola@lognow.pt</a>
              </li>
              <li className="flex items-center">
                <Phone size={18} className="text-[#8cc63f] mr-2" />
                <a href="tel:+351220941891" className="text-white/70 hover:text-[#8cc63f] transition-colors">+351 220 941 891</a>
              </li>
              <li className="flex items-start">
                <MapPin size={18} className="text-[#8cc63f] mr-2 mt-1" />
                <span className="text-white/70">Rua da Lavandeira 1407<br />4485-704 Vila Chã<br />Portugal</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Comece Já</h3>
            <p className="text-white/70 mb-4">Registe-se hoje e comece a vender em menos de 24 horas!</p>
            <Link to="/register" className="inline-block px-6 py-3 rounded-lg bg-[#8cc63f] text-white hover:bg-[#7ab52f] transition-colors font-medium w-full text-center">
              CRIAR CONTA GRÁTIS
            </Link>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8 mt-8 text-center">
          <p className="text-white/50 text-sm">
            &copy; {new Date().getFullYear()} LOGNOW. Todos os direitos reservados. Desenvolvido por Plataforma Concreta.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
